export type CpuFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type CpuFilterGroup = {
  id: string;
  label: string;
  options: CpuFilterOption[];
};

export const cpuFilterGroups: CpuFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'amd', label: 'CPU AMD', keywords: ['cpu amd', 'amd'] },
      { value: 'intel', label: 'CPU INTEL', keywords: ['cpu intel', 'intel'] },
      { value: 'tray', label: 'CPU TRAY', keywords: ['tray', 'no box'] },
    ],
  },
  {
    id: 'model',
    label: 'Model',
    options: [
      { value: 'i3', label: 'Core i3', keywords: ['core i3', 'i3'] },
      { value: 'i5', label: 'Core i5', keywords: ['core i5', 'i5'] },
      { value: 'i7', label: 'Core i7', keywords: ['core i7', 'i7'] },
      { value: 'i9', label: 'Core i9', keywords: ['core i9', 'i9'] },
      { value: 'r5', label: 'Ryzen 5', keywords: ['ryzen 5', 'r5'] },
      { value: 'r7', label: 'Ryzen 7', keywords: ['ryzen 7', 'r7'] },
      { value: 'r9', label: 'Ryzen 9', keywords: ['ryzen 9', 'r9'] },
      { value: 'u5', label: 'Core Ultra 5', keywords: ['core ultra 5', 'ultra 5'] },
      { value: 'u7', label: 'Core Ultra 7', keywords: ['core ultra 7', 'ultra 7'] },
      { value: 'u9', label: 'Core Ultra 9', keywords: ['core ultra 9', 'ultra 9'] },
      { value: 'threadripper', label: 'Threadripper PRO', keywords: ['threadripper', 'tr pro'] },
    ],
  },
  {
    id: 'gen',
    label: 'Thế hệ CPU',
    options: [
      { value: '10th', label: '10th Gen', keywords: ['10th gen', 'gen 10', '10th'] },
      { value: '12th', label: '12th Gen', keywords: ['12th gen', 'gen 12', '12th'] },
      { value: '13th', label: '13th Gen', keywords: ['13th gen', 'gen 13', '13th'] },
      { value: '14th', label: '14th Gen', keywords: ['14th gen', 'gen 14', '14th'] },
      { value: 'r3000', label: 'Ryzen 3000 Series', keywords: ['ryzen 3000', '3000 series'] },
      { value: 'r5000', label: 'Ryzen 5000 Series', keywords: ['ryzen 5000', '5000 series'] },
      { value: 'r7000', label: 'Ryzen 7000 Series', keywords: ['ryzen 7000', '7000 series'] },
      { value: 'r8000', label: 'Ryzen 8000 Series', keywords: ['ryzen 8000', '8000 series'] },
      { value: 'r9000', label: 'Ryzen 9000 Series', keywords: ['ryzen 9000', '9000 series'] },
    ],
  },
  {
    id: 'socket',
    label: 'Socket',
    options: [
      { value: 'lga1151', label: 'LGA 1151', keywords: ['lga1151', 'lga 1151'] },
      { value: 'lga1200', label: 'LGA 1200', keywords: ['lga1200', 'lga 1200'] },
      { value: 'lga1700', label: 'LGA 1700', keywords: ['lga1700', 'lga 1700'] },
      { value: 'lga2066', label: 'LGA 2066', keywords: ['lga2066', 'lga 2066'] },
      { value: 'lga3647', label: 'LGA 3647', keywords: ['lga3647', 'lga 3647'] },
      { value: 'lga4677', label: 'LGA 4677', keywords: ['lga4677', 'lga 4677'] },
      { value: 'am4', label: 'AM4', keywords: ['am4'] },
      { value: 'am5', label: 'AM5', keywords: ['am5'] },
      { value: 'strx4', label: 'sTRX4', keywords: ['strx4'] },
      { value: 'tr4', label: 'TR4', keywords: ['tr4'] },
      { value: 'sp3', label: 'SP3', keywords: ['sp3'] },
    ],
  },
  {
    id: 'ram-support',
    label: 'Hỗ trợ loại RAM',
    options: [
      { value: 'ddr3', label: 'DDR3', keywords: ['ddr3'] },
      { value: 'ddr4', label: 'DDR4', keywords: ['ddr4'] },
      { value: 'ddr5', label: 'DDR5', keywords: ['ddr5'] },
    ],
  },
];
